'use client';

import React from 'react';

/**
 * AboutBostonViolationsModal component
 *
 * Displays information about what Boston violations, complaints, and requests are and how they work.
 * Based on the Figma design for "About Boston violations" modal.
 */
export function AboutBostonViolationsModal() {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-2 px-2">
        <div className="flex flex-col gap-2 text-body-2 text-secondary rounded-2xl">
          <p>
            A violation is issued to a building when a city inspector from Boston's Office of
            Housing validates and confirms a complaint made to BOS:311 and the City's Inspectional
            Services Division.
          </p>
          <p>
            The violations listed below are open violations that have yet to be addressed or have
            not been confirmed as resolved by the city.
          </p>
        </div>
      </div>
    </div>
  );
}
